import { usePathname, useSearchParams } from 'next/navigation';

import { searchParamsToObject, type LinkProps } from '@packages/shared';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { UseSearchResultDataForCategoryFilterFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseSearchResultDataForCategoryFilterFragmentFragmentDoc';

import type { CategoryFilterItem } from '../CategoryFilterStandalone';

/* GraphQL */ `
  fragment UseSearchResultDataForCategoryFilterFragment on SuccessfulSearchResult {
    categories {
      id
      name
      level
      isSelected
      isSelectedExact
      styleCount
    }
  }
`;

// TODO dissolve this hook and move code into component after i18n changes from FETW-14 are merged, with gql changes etc. it is not complex enough anymore to justify a hook
export const useSearchResultDataForCategoryFilter = (
  maskedData: FragmentType<typeof UseSearchResultDataForCategoryFilterFragmentFragmentDoc>,
): CategoryFilterItem[] => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const query = searchParamsToObject(searchParams);

  const data = getFragmentData(UseSearchResultDataForCategoryFilterFragmentFragmentDoc, maskedData);

  const generateCategoryHref = (categoryId: string) =>
    ({
      pathname,
      query: { ...query, c: categoryId },
    }) as LinkProps['href'];

  return data.categories.map(({ id, name, level, isSelected, isSelectedExact, styleCount }) => ({
    id,
    name,
    level,
    isSelected,
    isSelectedExact,
    count: styleCount,
    href: generateCategoryHref(id),
  }));
};
